import ThisModule from "./SingleSessionPricesSection";

export default ThisModule;
